// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 接龙格式化页面
import format from '@/views/format';
// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
//房型管理
import RoomAttribute from "@/views/basic/RoomAttribute";
//房间管理
import Room from "@/views/basic/Room";
/**
 * 实时账单管理
 */
import revenueFlow from "../views/realTimeBill/revenueFlow";
import expenseBill from "../views/realTimeBill/expenseBill";

/**
 * 股东分红
 */
import ShareHolder from "../views/shareholder/ShareHolder";
import Dividend from "../views/shareholder/Dividend";
// 日志管理
import OperationLog from "../views/system/OperationLog";
// 充电桩记账
import charging from "../views/realTimeBill/charging";
// 账号管理
import UserManage from "../views/system/UserManage";

/**
 * 系统管理
 */
// 用户管理
import user from '@/views/system/user';
// 菜单管理
import Module from '@/views/system/Module';
// 角色管理
import Role from '@/views/system/Role';
// 公司管理
import Dept from '@/views/system/Dept';
// 系统环境变量
import Variable from '@/views/system/Variable';
// 权限管理
import Permission from '@/views/system/Permission';

/**
 * 数据监控
 */
// 监控查询
import druidLogin from '@/views/druid/login';

// 图表界面
import statistics from '@/views/charts/statistics';


// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
      path: '/format',
      name: '格式化页面',
      component: format,
      hidden: true,
      meta: {
        requireAuth: false
      }
    }, {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [{
            path: '/system/user',
            name: '用户管理',
            component: user,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Module',
            name: '菜单管理',
            component: Module,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Role',
            name: '角色管理',
            component: Role,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Dept',
            name: '公司管理',
            component: Dept,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Variable',
            name: '系统环境变量',
            component: Variable,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Permission',
            name: '权限管理',
            component: Permission,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/druid/login',
            name: '监控查询',
            component: druidLogin,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/charts/statistics',
            name: '数据可视化',
            component: statistics,
            meta: {
                requireAuth: true
            }
        },{
          path:'/basic/Room',
          name:'房间管理',
          component:Room,
          meta:{
            requireAuth: true
          }
        },{
          path:'/basic/RoomAttribute',
          name:'房型管理',
          component:RoomAttribute,
          meta:{
            requireAuth: true
          }
        },{
          path:'/realTimeBill/revenueFlow',
          name:'本月入账',
          component:revenueFlow,
          meta:{
            requireAuth: true
          }
        },{
          path:'/realTimeBill/expenseBill',
          name:'本月支出',
          component:expenseBill,
          meta:{
            requireAuth: true
          }
        },{
          path:'/shareholder/ShareHolder',
          name:'股东管理',
          component:ShareHolder,
          meta:{
            requireAuth: true
          }
        },{
          path:'/shareholder/Dividend',
          name:'分红记录',
          component:Dividend,
          meta:{
            requireAuth: true
          }
        },{
          path:'/system/OperationLog',
          name:'日志管理',
          component:OperationLog,
          meta:{
            requireAuth: true
          }
        },{
          path:'/realTimeBill/charging',
          name:'充电桩记账',
          component:charging,
          meta:{
            requireAuth: true
          }
        },{
          path:'/system/UserManage',
          name:'账号管理',
          component:UserManage,
          meta:{
            requireAuth: true
          }
        }]
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js